import * as React from 'react';
import { BrowserRouter as Router, Route, Link, Switch, RouteProps, Redirect } from 'react-router-dom';
import { Dropdown, Button } from 'semantic-ui-react';
import OAuth, { OAuthClientStatus } from './api';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import DocumentTitle from 'react-document-title';
import Content from './sys/content';
import { Toaster } from './sys/toast';
import AppContext from './views/appContext';
import AssetsView from './views/assets';
import CensusView from './views/census';
import TransactionLogView from './views/logs/transactionlog';
import AlarmLogView from './views/logs/alarmlog';
import DAILogView from './views/logs/daiLog';
import AlarmTemplateView from './views/config/alarmTemplate/alarmTemplates';
import Dashboard from './views/dashboard';
import AssetAliasView from './views/config/assetAlias';
import VODAssetAliasView from './views/config/vodAssetAlias';
import EventAliasView from './views/config/eventAlias';
import StreamStatsView from './views/monitoring/streamStats';
import LoginView from './views/login';
import SystemConfigView from './views/config/system/systemConfig';
import AboutWindow from './views/config/aboutWindow';
import UserSettingsWindow from './views/config/userSettings';
import ChangePasswordWindow from './views/config/changePassword';
import RvlStatusView from './views/monitoring/rvlStatus';
import MonitorConfigView from './views/config/monitoring/monitorConfig';
import SecurityConfigView from './views/config/security/securityConfig';
import SystemInfoView from './views/config/systemInfo/systemInfo';
import CaptureView from './views/config/capture';
import SchedulerView from './views/monitoring/scheduler';
import VodCensusView from './views/vodCensus';
import VodStatusView from './views/monitoring/vodStatus';
import AliasConfigView from './views/config/aliasConfig';
import WifiConfigView from './views/monitoring/wifiConfig';
import CliView from './views/cli';
import 'es6-shim';

import './css/burgers-push.css';
import './css/triton-theme.css';
import 'font-awesome/css/font-awesome.css';
import './css/App.css';
import './css/columns.css';
import './css/billboard.css';
import './sys/kpi/kpi.css';
import './sys/kpi/micro-ring.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-treeview/react-treeview.css';
import './css/ineo-triton-theme.css';
import './css/iq-triton-theme-extn.css';
import './css/toggle.css';

const logo = require('./img/SABR_logo.png');
const FontAwesome = require('react-fontawesome');
const qs = require('qs');

const ErrorPage = (className: string, title: string, description: string, delay: number = 3000) => () => {
    window.setTimeout(() => window.location.href = '/', delay);
    return (
        <div className={'page-unavailable ' + className}>
            <h1>{title}</h1>
            <p>{description}</p>
        </div>
    );
};

const PageNotFound = ErrorPage(
    'route404',
    'Page not found',
    'The requested page was invalid. You will now be redirected to your home page.'
);

const PageProtected = ErrorPage(
    'route401',
    'Access Denied',
    'The requested page is protected and not available to your security level. Request upgraded credentials from your administrator.'
);

// RouterIf: functional Route component renders only if test expression is true
// note: we specify the props type as "RouteProps & { test: boolean }" to inherit from RouteProps but include test
// property as type boolean. If the test fails, the user is redirected to an access-denied page then to their home page.
const ProtectedRoute = ({test, ...other}: RouteProps & { test: boolean }) => test
    ? <Route {...other} />
    : <Redirect to="/access-denied" />;

interface Props {
}

interface State {
    outages: number;
    host: string;
    showAboutWindow: boolean;
    showUserSettings: boolean;
    showChangePassword: boolean;
    homePage: any;
    activeIndex: number;
    compactHardware: boolean;
    wifiEnabled: boolean;
    currentTime: string;
    isAdmin: any;
    sysName: string;
    setTitle: any;
}

class App extends React.Component<Props, State> {

    isSecureSite(): boolean {
        return window.location && window.location.protocol === 'https:';
    }

    componentWillMount() {
        let host, homePage;
        const groupSet = window.localStorage.getItem('group-set');

        if (groupSet === '' || groupSet === null) {
            window.localStorage.setItem('group-set', JSON.stringify({'set': ['Summary']}));      // setting default census screen group selections
        }

        // check for host query string parameter
        if (window.location.search.startsWith('?')) {
            host = qs.parse(window.location.search.substr(1)).host;
            if (host)
                window.localStorage.setItem('host', host);
            // tslint:disable-next-line:no-console
            console.log('determined host via query string: ', host);
        } else if (window.localStorage && (host = window.localStorage.getItem('host'))) {
            // tslint:disable-next-line:no-console
            console.log('determined host via local storage: ', host);
        } else
            host = window.location.host;

        if (window.localStorage && (window.localStorage.getItem('homePage'))) {
            homePage = window.localStorage.getItem('homePage');
        }

        this.setState({
            host,
            homePage,
            outages: 3,
            showAboutWindow: false,
            showUserSettings: false,
            showChangePassword: false,
            activeIndex: 0,
            compactHardware: false,
            wifiEnabled: false,
            sysName: 'Surveyor ABR Active',
            setTitle: this.setSysName
        });

        this.getlogo(host);
        this.getCurrentTime();
    }

    render() {
        const homePageOptions = [   {value: 'CensusView', text: 'Census'},
                                    {value: 'AssetsView', text: 'Asset Status'},
                                    {value: 'AlarmLogView', text: 'Alarm Log'},
                                    {value: 'TransactionLogView', text: 'Transaction Log'}
        ];

        return (
            <DocumentTitle title={this.state.sysName}>
            <OAuth
                key="oauth"
                host={this.state.host}
                secureHost={this.isSecureSite()}
            >
                <AppContext.Provider value={this.state.setTitle}>
                <Toaster defaultTimeout={1500} />

                <OAuth.View login>
                    <LoginView compactHardware={this.state.compactHardware}/>
                </OAuth.View>
                <OAuth.View authenticated>
                    <Router>
                        <OAuth.Context>{ (oauth: OAuthClientStatus) => {
                            const isAdmin = oauth.level === 'admin';
                            return (
                            <div className="App" id="app">
                                <div className="page-top">
                                    <div id="banner">
                                        <div id="logo-section">
                                            <div>
                                                <img src={logo} alt="logo"/>
                                            </div>
                                        </div>
                                        <div className="banner-section" id="menu-section">
                                            <Button className="hamburger-menu-button" as={Link} to="/" onClick={() => this.forceUpdate()}>
                                                <FontAwesome name="home" style={{fontSize: '18px', color: 'white'}}/>
                                            </Button>
                                            <Dropdown className="bannerMenuItem" item text="MONITORING">
                                                <Dropdown.Menu className="monitoringMenu">
                                                    <OAuth.RequiresAdmin>
                                                        { !oauth.VODOnlyLicensePresent &&
                                                        <Dropdown.Item as={Link} to="/assets">Asset Status</Dropdown.Item>
                                                        }
                                                    </OAuth.RequiresAdmin>
                                                    { !oauth.VODOnlyLicensePresent &&
                                                    <Dropdown.Item as={Link} to="/census">Census</Dropdown.Item>
                                                    }
                                                    <OAuth.RequiresAdmin>
                                                        { !oauth.VODOnlyLicensePresent &&
                                                        <Dropdown.Item as={Link} to="/monitoring/rvl">RVL Status</Dropdown.Item>
                                                        }
                                                        { !oauth.VODOnlyLicensePresent &&
                                                        <Dropdown.Item as={Link} to="/monitoring/scheduler">Scheduler</Dropdown.Item>
                                                        }
                                                        {(this.state.wifiEnabled) && <Dropdown.Item as={Link} to="/monitoring/wifiConfig">Wi-Fi</Dropdown.Item>}
                                                    </OAuth.RequiresAdmin>
                                                    { (oauth.VODLicensePresent || oauth.VODOnlyLicensePresent) &&
                                                    <Dropdown.Item as={Link} to="/monitoring/vodStatus">VOD Status</Dropdown.Item>
                                                    }
                                                    { (oauth.VODLicensePresent || oauth.VODOnlyLicensePresent) &&
                                                    <Dropdown.Item as={Link} to="/monitoring/vodCensus">VOD Census</Dropdown.Item>
                                                    }
                                                    {/*<OAuth.Feature VOD><Dropdown.Item as={Link} to="/monitoring/vodStatus">VOD Status</Dropdown.Item></OAuth.Feature>*/}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <Dropdown item text="DIAGNOSTICS" className="bannerMenuItem">
                                                <Dropdown.Menu className="diagnosticsMenu" >
                                                    <Dropdown.Item as={Link} to="/logs/transaction">Transaction Log</Dropdown.Item>
                                                    <Dropdown.Item as={Link} to="/logs/alarm">Alarm Log</Dropdown.Item>
                                                    {/*<OAuth.RequiresAdmin>*/}
                                                        <OAuth.Feature DAI><Dropdown.Item as={Link} to="/logs/dai">Dynamic Ad Insertion Log</Dropdown.Item></OAuth.Feature>
                                                        <Dropdown.Item as={Link} to="/config/capture">Capture</Dropdown.Item>
                                                    {/*</OAuth.RequiresAdmin>*/}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <OAuth.Context>
                                                {(oauth2: OAuthClientStatus) => { // OK
                                                    const mode = oauth2.sys && oauth2.sys.interface;
                                                    return mode ? <span className={`interface-mode interface-mode-${mode}`}>{mode}</span> : null;
                                                }}
                                            </OAuth.Context>
                                            <OAuth.Context>
                                                {(oauth2: OAuthClientStatus) => { // OK
                                                    const licensed = oauth2.features && oauth2.features.Licensed;
                                                    return !licensed ? <span className={`interface-check interface-check-unlicensed`}>Not Licensed</span> : null;
                                                }}
                                            </OAuth.Context>
                                        </div>
                                        <div id="iconic-menu-section" className="banner-time">
                                            <span className="banner-section">
                                                {this.state.currentTime}
                                            </span>
                                            <Dropdown item icon="help circle" className="banner-icon">
                                                <Dropdown.Menu className="hamburgerMenu">
                                                    <OAuth.RequiresAdmin>
                                                        <Dropdown.Item onClick={() => this.launchAboutWindow(0)}>Version</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.launchAboutWindow(1)}>License Details</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.launchAboutWindow(2)}>License Agreement</Dropdown.Item>
                                                    </OAuth.RequiresAdmin>
                                                    <Dropdown.Item as={Link} to="/config/systemInfo">System Info</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <Dropdown item icon="user circle" className="banner-icon">
                                                <Dropdown.Menu className="hamburgerMenu">
                                                    <OAuth.RequiresAdmin>
                                                        <Dropdown.Item onClick={() => {this.setState({showUserSettings: true}); }}>User Settings</Dropdown.Item>
                                                    </OAuth.RequiresAdmin>
                                                    <OAuth.RequiresLdap>
                                                        {atob(oauth.clientID as string) === 'Admin' &&
                                                        <Dropdown.Item onClick={() => {this.setState({showChangePassword: true}); }}>Change Password</Dropdown.Item>
                                                        }
                                                    </OAuth.RequiresLdap>
                                                    <OAuth.LdapDisabled>
                                                        <Dropdown.Item onClick={() => {this.setState({showChangePassword: true}); }}>Change Password</Dropdown.Item>
                                                    </OAuth.LdapDisabled>
                                                    <Dropdown.Item as={Link} to="/" onClick={() => oauth.signOut()}>Sign Out [{atob(oauth.clientID as string)}]</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <OAuth.RequiresAdmin>
                                                    <Dropdown item icon="bars" className="banner-hamburger-menu">
                                                        <Dropdown.Menu className="hamburgerMenu">
                                                            { !oauth.VODOnlyLicensePresent &&
                                                            <Dropdown.Item as={Link} to="/config/assetAlias">Asset Aliases</Dropdown.Item>
                                                            }
                                                            <OAuth.Feature VOD><Dropdown.Item as={Link} to="/config/vodAlias">VOD Aliases</Dropdown.Item></OAuth.Feature>
                                                            <OAuth.Feature VODOnly><Dropdown.Item as={Link} to="/config/vodAlias">VOD Aliases</Dropdown.Item></OAuth.Feature>
                                                            { !oauth.VODOnlyLicensePresent &&
                                                            <Dropdown.Item as={Link} to="/config/eventAlias">Event Aliases</Dropdown.Item>
                                                            }
                                                            <Dropdown.Item as={Link} to="/config/alarmTemplates">Alarm Template</Dropdown.Item>
                                                            <Dropdown.Item as={Link} to="/config/monitorConfig">Monitoring</Dropdown.Item>
                                                            <Dropdown.Item as={Link} to="/config/assetConfig">Variant Aliasing</Dropdown.Item>
                                                            <Dropdown.Item as={Link} to="/config/securityConfig">Security</Dropdown.Item>
                                                            <Dropdown.Item as={Link} to="/config/systemConfig">System</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                            </OAuth.RequiresAdmin>
                                        </div>
                                    </div>
                                    <AboutWindow
                                        showModal={this.state.showAboutWindow}
                                        handleAboutModalClose={() => this.handleAboutWindowClose()}
                                        activeIndex={this.state.activeIndex}
                                    />
                                    <UserSettingsWindow
                                        showModal={this.state.showUserSettings}
                                        handleModalClose={() => this.handleUserSettings()}
                                        options={homePageOptions}
                                        changeHomepage={(props: any) => this.setHomePage(props)}
                                    />
                                    <ChangePasswordWindow
                                        showModal={this.state.showChangePassword}
                                        handlePasswordModalClose={() => this.handlePasswordModalClose()}
                                    />
                                </div>
                                <Content.workspace id="main-workspace">

                                    <Switch>
                                        <Route path="/" exact component={this.getHomePage(oauth)}/>
                                        <Route path="/web" exact component={this.getHomePage(oauth)}/>
                                        <Route path="/cmd/nui" exact component={this.getHomePage(oauth)}/>
                                        <Route path="/dashboard" exact component={Dashboard}/>
                                        <Route path="/census" exact component={CensusView}/>
                                        <Route path="/config/systemInfo" exact component={SystemInfoView}/>

                                        <Route path="/logs/transaction" exact component={TransactionLogView}/>
                                        <Route path="/logs/alarm" exact component={AlarmLogView}/>

                                        <Route path="/monitoring/vodCensus" exact component={VodCensusView}/>
                                        <Route path="/monitoring/vodStatus" exact component={VodStatusView}/>
                                        <Route path="/config/capture" exact component={CaptureView}/>
                                        <Route path="/logs/dai" exact component={DAILogView}/>

                                        {/*<ProtectedRoute test={isAdmin} path="/logs/dai" exact component={DAILogView}/>*/}

                                        <ProtectedRoute test={isAdmin} path="/assets" exact component={AssetsView}/>
                                        <ProtectedRoute test={isAdmin} path="/monitoring/streamStats" exact component={StreamStatsView}/>
                                        <ProtectedRoute test={isAdmin} path="/monitoring/rvl" exact component={RvlStatusView}/>
                                        <ProtectedRoute test={isAdmin} path="/monitoring/scheduler" exact component={SchedulerView}/>
                                        <ProtectedRoute test={isAdmin} path="/monitoring/wifiConfig" exact component={WifiConfigView} />
                                        {/*<ProtectedRoute test={isAdmin} path="/monitoring/vodStatus" exact component={VodStatusView}/>*/}

                                        <ProtectedRoute test={isAdmin} path="/config/assetAlias" exact component={AssetAliasView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/vodAlias" exact component={VODAssetAliasView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/eventAlias" exact component={EventAliasView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/assetConfig" exact component={AliasConfigView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/systemConfig" exact component={SystemConfigView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/alarmTemplates" exact component={AlarmTemplateView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/monitorConfig" exact component={MonitorConfigView}/>
                                        <ProtectedRoute test={isAdmin} path="/config/securityConfig" exact component={SecurityConfigView}/>
                                        {/*<ProtectedRoute test={isAdmin} path="/config/capture" exact component={CaptureView}/>*/}

                                        <ProtectedRoute test={isAdmin} path="/cli2" exact component={CliView}/>

                                        <Route path="/access-denied" exact component={PageProtected}/>
                                        <Route component={PageNotFound}/>
                                    </Switch>

                                    <Content.row id="content-bottom"/>
                                </Content.workspace>
                                <div className="page-bottom" />
                            </div>
                            ); }}</OAuth.Context>
                    </Router>
                    </OAuth.View>
                </AppContext.Provider>
            </OAuth>
            </DocumentTitle>
        );
    }

    getHomePage(oauth: OAuthClientStatus) {
        if (oauth.sys && oauth.sys.interface === 'vod') {
            return VodStatusView;
        } else {
            switch (this.state.homePage) {
                case 'CensusView':
                    return CensusView;
                case 'AssetsView':
                    return AssetsView;
                case 'AlarmLogView':
                    return AlarmLogView;
                case 'TransactionLogView':
                    return TransactionLogView;
                default:
                    this.setState({
                      homePage: 'CensusView'
                    });
                    window.localStorage.setItem('homePage', 'CensusView');
                    return CensusView;
            }
        }
    }

    setHomePage(props: any) {
        this.setState({
            homePage: props,
            showUserSettings: false
        });
        window.localStorage.setItem('homePage', props);
    }

    setSysName = (title: any) => {
        this.setState({
           sysName: title
        });
    }

    handleAboutWindowClose() {
        this.setState({
            showAboutWindow: false
        });
    }
    handleUserSettings() {
        this.setState({
            showUserSettings: false
        });
    }
    handlePasswordModalClose() {
        this.setState({
            showChangePassword: false
        });
    }
    launchAboutWindow(activeIndex: number) {
        this.setState({
            showAboutWindow: true,
            activeIndex: activeIndex
        });
    }
    getlogo(host: any) {
        let _this = this;
        let url = 'http://' + host + '/js/boot.html';
        if (this.isSecureSite()) {
            url = 'https://' + host + '/js/boot.html';
        }
        axios.get(url)
            .then((resp: AxiosResponse) => {
                if (resp.data !== undefined) {
                    let compactHardware = resp.data.compact;
                    let wifiEnabled = resp.data.wifi;
                    let sysName = 'Surveyor ABR Active';
                    if (resp.data.sysName !== '') {
                        sysName += ' (' + resp.data.sysName + ')';
                    }
                    _this.setState({
                        compactHardware: compactHardware,
                        wifiEnabled: wifiEnabled,
                        sysName: sysName
                    });
                } else {
                    throw resp;
                }
            })
            .catch( (err: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('expected system boot info, got', err);
            });
    }
    getCurrentTime() {
        let date = new Date();
        let dateTime = date.getTime();
        let timeInMillis = dateTime + date.getTimezoneOffset();
        let newDate = new Date();
        newDate.setTime(timeInMillis);

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        const mo = (newDate.getUTCMonth());
        const dt = ('0' + newDate.getUTCDate()).slice(-2);
        const hr = ('0' + newDate.getHours()).slice(-2);
        const mi = ('0' + newDate.getUTCMinutes()).slice(-2);
        const yr = newDate.getUTCFullYear() ;

        let tzName = date.toLocaleString('en', {timeZoneName: 'short'}).split(' ').pop();
        let returnStr = dt + ' ' + monthNames[mo] + ' ' +  yr + '  ' + hr + ':' + mi + ' ' + tzName;
        if (this.state && returnStr !== this.state.currentTime) {
            this.setState({
                currentTime: returnStr
            },            () => this.updateTime());
        } else this.updateTime();
    }

    updateTime() {
        setTimeout(() => this.getCurrentTime(), 10000);
    }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx